import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import initialiser from '../../utils/initialiser';

import App from './containers/App';
import { store } from './store';

class CreateYourOwnPackage {
  readonly container: HTMLElement;

  constructor({ el }) {
    this.container = el;
  }

  init = () => {
    ReactDOM.render(
      <React.StrictMode>
        <Provider store={store}>
          <App node={this.container} />
        </Provider>
      </React.StrictMode>,
      this.container,
    );
  };
}

// Export component wrapped in initialiser utility
export default (settings) => initialiser(settings, CreateYourOwnPackage);
